import React, { useEffect, useState } from "react";
import AddButton from "../../../components/admin/usable/AddButton";
import { useNavigate } from "react-router";
import Pagination from "@mui/material/Pagination";
import { blogList, deleteBlog } from "../../../api/admin/blogApi";
import TableLoader from "../../../components/admin/usable/TableLoader";
import EditButton from "../../../components/admin/usable/actions/EditButton";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";
import { deleterOffer, offerList } from "../../../api/admin/offerApi";

const OfferList = () => {
  const navigate = useNavigate();
  const [OfferData, setOfferData] = useState([]);
  const [PaginationData, setPaginationData] = useState("");
  const [Page, setPage] = useState(1);
  const [Limit, setLimit] = useState(10);
  const handleAddNewOffer = () => {
    navigate("/admin/offer/create");
  };
  useEffect(() => {
    offerList(setOfferData, setPaginationData, Page, Limit);
  }, [Page, Limit]);
  const handleShowmore = (e) => {
    setPage((prev) => prev + 1);
  };
  const handleDelete = (item) => {
    const id = item.id;
    deleterOffer(setOfferData, setPaginationData, Page, Limit, id);
  };
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <p className="font-bold">Offer List</p>
        <AddButton onClick={handleAddNewOffer} text="Add New Offer" />
      </div>
      <div className="w-full overflow-x-auto bg-white rounded-lg drop-shadow-md">
        <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                ID
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Cover
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Offer Title
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Category
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Discount
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Coupon Code
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Expiration Date
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Is Featured?
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Status
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                CreatedAt
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Action
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200">
            {OfferData.length > 0 ? (
              <>
                {OfferData.map((item, index) => {
                  const formatDate = (date) => {
                    if (!date || typeof date !== "string") return "N/A";
                    return date.split("T")[0];
                  };

                  return (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {index + 1}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <div className="w-20 h-12 overflow-hidden rounded-lg">
                          <img
                            className="w-full h-full object-cover"
                            src={item.featuredImage}
                            alt=""
                          />
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <a href="#" target="_blank" rel="noopener noreferrer">
                          {item.offerTitle}
                        </a>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs">
                          {item.category}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {item.discount ? `${item.discount}%` : "N/A"}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {item.code}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {formatDate(item?.expirationDate)}
                      </td>
                      <td className="px-4 py-3 text-sm">
                        <span
                          className={`px-2 py-1 ${
                            item.isFeatured === 1
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-red-700"
                          } rounded text-xs`}
                        >
                          {item.status === 1 ? "Yes" : "No"}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm">
                        <span
                          className={`px-2 py-1 ${
                            item.status === 1
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-red-700"
                          } rounded text-xs`}
                        >
                          {item.status === 1 ? "Published" : "Unpublished"}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {formatDate(item?.createdAt)}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 flex gap-x-2">
                        <EditButton
                          onClick={() =>
                            navigate(`/admin/offer/edit/${item.id}`)
                          }
                        />{" "}
                        <DeleteButton onClick={() => handleDelete(item)} />
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <TableLoader colSpan={8} />
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center">
        <div>
          <p>
            Showing {OfferData.length} of {PaginationData} entries
          </p>
        </div>
        <div>
          <Pagination
            onChange={handleShowmore}
            count={PaginationData}
            variant="outlined"
          />
        </div>
      </div>
    </div>
  );
};

export default OfferList;
